import React from "react";
import { useAppTranslation } from "../../locales/translate";

export const ErrorImage = () => {
  const { t } = useAppTranslation();

  return (
    <img
      src="https://static.finncdn.no/_c/saved-search-settings-podlet/images/error-list.svg"
      alt={t("ERROR_MODAL_IMAGE_ALT_TEXT")}
      width={145}
      height={108}
    />
  );
};
